import { TYPE_NATCOM_AIRTIME, TYPE_NATCOM_DIGICEL_VMAIL, TYPE_NATCOM_NTM, TYPE_NATCOM_VMAIL_AIRTIME, TYPE_NATCOM_VMAIL_DIGICEL } from "./type";

export const getDataNatcom = (url) => {
  return {
    type: TYPE_NATCOM_VMAIL_AIRTIME,
    meta: {
      url,
      method: "GET",
    },
  };
};


export const getDataNatcomDigicelVm = (url) => {
  return {
    type: TYPE_NATCOM_DIGICEL_VMAIL,
    meta: {
      url,
      method: "GET",
    },
  };
};


export const getDataNatcomNtm = (url) => {
  return {
    type: TYPE_NATCOM_NTM,
    meta: {
      url,
      method: "GET",
    },
  };
};

export const getDataNatcomAirtime = (url) => {
  return {
    type: TYPE_NATCOM_AIRTIME,
    meta: {
      url,
      method: "GET",
    },
  };
};